import styled from "styled-components";

const SIDEBAR_W = "200px";
const TOPBAR_H  = "68px";

export const TopBar = styled.header`
  position: fixed;
  top: 0; left: 0; right: 0;
  height: ${TOPBAR_H};
  display: flex;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #e0e8f0;
  z-index: 200;
`;

export const TopBarLogo = styled.div`
  width: ${SIDEBAR_W};
  min-width: ${SIDEBAR_W};
  padding: 0 18px;
  display: flex;
  align-items: center;
  height: 100%;
  border-right: 1px solid #e0e8f0;
`;

export const TopBarContent = styled.div`
  flex: 1;
  padding: 0 32px;
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const Layout = styled.div`
  display: flex;
  min-height: 100vh;
  background: #e8f2f7;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  padding-top: ${TOPBAR_H};
`;

export const Main = styled.main`
  margin-left: ${SIDEBAR_W};
  flex: 1;
  padding: 28px 32px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SectionTitle = styled.h1`
  margin: 0;
  font-size: 1.6rem;
  font-weight: 700;
  color: #2F6D92;
  white-space: nowrap;
`;

export const ProgressBarWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

export const ProgressBarTrack = styled.div`
  width: 420px;
  height: 10px;
  background: #d8e8f2;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
`;

export const ProgressBarFill = styled.div`
  height: 100%;
  width: ${({ $pct }) => $pct}%;
  background: #2F6D92;
  border-radius: 8px;
  transition: width 0.3s;
`;

export const ProgressLabel = styled.span`
  font-size: 0.8rem;
  color: #888;
  white-space: nowrap;
`;

export const TabsRow = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const Tab = styled.button`
  padding: 6px 18px;
  border-radius: 20px;
  border: none;
  background: ${({ $active }) => ($active ? "#2F6D92" : "transparent")};
  color: ${({ $active }) => ($active ? "#fff" : "#666")};
  font-size: 0.85rem;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  cursor: pointer;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: ${({ $active }) => ($active ? "#2F6D92" : "#dce8f0")};
    color: ${({ $active }) => ($active ? "#fff" : "#2F6D92")};
  }
`;

export const ActivitiesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`;

export const ActivityCard = styled.div`
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.07);
  padding: 18px 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

export const CardIcon = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: #ede9f8;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #7b61c4;
`;

export const CardName = styled.h3`
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #1b3a6b;
  flex: 1;
`;

export const LoggedBadge = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #2e9e5b;
  white-space: nowrap;
`;

export const TagsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const Tag = styled.span`
  padding: 3px 10px;
  border-radius: 12px;
  background: #ede9f8;
  color: #7b61c4;
  font-size: 0.75rem;
  font-weight: 500;
`;

export const CardDescription = styled.p`
  margin: 0;
  font-size: 0.82rem;
  color: #666;
  line-height: 1.5;
  flex: 1;
`;

export const CardButton = styled.button`
  padding: 9px 10px;
  border: none;
  border-radius: 8px;
  background: #79BEE6;
  color: #fff;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  width: 100%;

  &:hover { background: #1d8f9b; }
`;
